import React from 'react';
type NoteAddProps = {
  width?: string;
  height?: string;
  color?: string;
  stroke?: string;
  strokeLinecap?: string;
  strokeLinejoin?: string;
  strokeWidth?: string;
};
function NoteAdd({
  width = '24',
  height = '24',
  color = 'black',
  strokeLinecap = 'round',
  strokeLinejoin = 'round',
  strokeWidth = '2',
}: NoteAddProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z'
        stroke={color}
        stroke-width={strokeWidth}
        stroke-linecap={strokeLinecap}
        stroke-linejoin={strokeLinejoin}
      />
    </svg>
  );
}

export default NoteAdd;
